// extracted by mini-css-extract-plugin
export default {"loadingSec":"Loading_loadingSec__5lrxM","loader":"Loading_loader__uAd0W","pulse":"Loading_pulse__9UlX3","scaleUp":"Loading_scaleUp__7FzAu"};